import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { products } from '../../data/products';

const ProductSlider = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  // Select featured products from different categories
  const featuredProducts = [
    // Electronics - More variety
    products.find(p => p.category === 'Electronics' && p.id === 1), // Wireless Bluetooth Headphones
    products.find(p => p.category === 'Electronics' && p.id === 2), // Smart Watch Series 5
    products.find(p => p.category === 'Electronics' && p.id === 3), // Wireless Phone Charger
    products.find(p => p.category === 'Electronics' && p.id === 4), // 4K Action Camera
    products.find(p => p.category === 'Electronics' && p.id === 5), // Gaming Mechanical Keyboard
    // Clothing - More options
    products.find(p => p.category === 'Clothing' && p.id === 16), // Premium Cotton T-Shirt
    products.find(p => p.category === 'Clothing' && p.id === 17), // Designer Denim Jeans
    products.find(p => p.category === 'Clothing' && p.id === 18), // Casual Summer Dress
    products.find(p => p.category === 'Clothing' && p.id === 19), // Leather Jacket
    products.find(p => p.category === 'Clothing' && p.id === 20), // Running Sneakers
    // Food - More variety
    products.find(p => p.category === 'Food' && p.id === 31), // Organic Coffee Beans
    products.find(p => p.category === 'Food' && p.id === 32), // Premium Dark Chocolate
    products.find(p => p.category === 'Food' && p.id === 33), // Artisan Honey
    products.find(p => p.category === 'Food' && p.id === 34), // Green Tea Collection
    // Sports - More equipment
    products.find(p => p.category === 'Sports' && p.id === 46), // Professional Yoga Mat
    products.find(p => p.category === 'Sports' && p.id === 47), // Adjustable Dumbbells
    products.find(p => p.category === 'Sports' && p.id === 48), // Resistance Bands Set
    products.find(p => p.category === 'Sports' && p.id === 49), // Basketball
  ].filter(Boolean);

  // Product videos (using placeholder videos from online sources)
  const productVideos = {
    1: 'https://player.vimeo.com/external/371433846.sd.mp4?s=236da2f3c0fd273d2c6d9a064f3ae35579b2bbdf&profile_id=139&oauth2_token_id=57447761',
    2: 'https://player.vimeo.com/external/374225534.sd.mp4?s=5c6de8c0e1eb1c15d8e8b5c5d5f5d5d5d5d5d5d5&profile_id=139',
    3: 'https://player.vimeo.com/external/385678901.sd.mp4?s=3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d&profile_id=139',
    4: 'https://player.vimeo.com/external/396789012.sd.mp4?s=4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e&profile_id=139',
    5: 'https://player.vimeo.com/external/407890123.sd.mp4?s=5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f&profile_id=139',
    16: 'https://player.vimeo.com/external/418901234.sd.mp4?s=6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a&profile_id=139',
    17: 'https://player.vimeo.com/external/429012345.sd.mp4?s=7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b&profile_id=139',
    18: 'https://player.vimeo.com/external/440123456.sd.mp4?s=8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c&profile_id=139',
    19: 'https://player.vimeo.com/external/451234567.sd.mp4?s=9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d&profile_id=139',
    20: 'https://player.vimeo.com/external/462345678.sd.mp4?s=0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e&profile_id=139',
    31: 'https://player.vimeo.com/external/473456789.sd.mp4?s=1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f&profile_id=139',
    32: 'https://player.vimeo.com/external/484567890.sd.mp4?s=2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a&profile_id=139',
    33: 'https://player.vimeo.com/external/495678901.sd.mp4?s=3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b&profile_id=139',
    34: 'https://player.vimeo.com/external/506789012.sd.mp4?s=4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c&profile_id=139',
    46: 'https://player.vimeo.com/external/517890123.sd.mp4?s=5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d&profile_id=139',
    47: 'https://player.vimeo.com/external/528901234.sd.mp4?s=6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e&profile_id=139',
    48: 'https://player.vimeo.com/external/539012345.sd.mp4?s=7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f&profile_id=139',
    49: 'https://player.vimeo.com/external/550123456.sd.mp4?s=8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f7a&profile_id=139'
  };

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % featuredProducts.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [featuredProducts.length]);

  const handleBuyNow = (productId) => {
    navigate(`/product/${productId}`);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % featuredProducts.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + featuredProducts.length) % featuredProducts.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  if (!featuredProducts.length) return null;

  return (
    <div className="relative w-full h-80 sm:h-96 md:h-[500px] lg:h-[600px] xl:h-[650px] overflow-hidden rounded-none sm:rounded-2xl shadow-2xl bg-gradient-to-r from-blue-600 to-purple-600">
      {/* Main Slider */}
      <div 
        className="flex transition-transform duration-700 ease-in-out h-full"
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {featuredProducts.map((product, index) => (
          <div key={product.id} className="min-w-full h-full relative">
            {/* Background Video */}
            <div className="absolute inset-0 overflow-hidden">
              <video
                className="w-full h-full object-cover opacity-30"
                autoPlay
                muted
                loop
                playsInline
              >
                <source src={productVideos[product.id]} type="video/mp4" />
                {/* Fallback to image if video fails */}
              </video>
              {/* Fallback background image */}
              <div 
                className="absolute inset-0 bg-cover bg-center opacity-50"
                style={{ backgroundImage: `url(${product.image})` }}
              />
            </div>

            {/* Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent" />

            {/* Content */}
            <div className="relative z-10 h-full flex items-center">
              <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-8 items-center">
                  {/* Product Info */}
                  <div className="text-white space-y-3 sm:space-y-6">
                    <div className="space-y-2">
                      <span className="inline-block px-2 sm:px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs sm:text-sm font-medium">
                        {product.category}
                      </span>
                      <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-tight">
                        {product.name}
                      </h2>
                    </div>
                    
                    <p className="text-sm sm:text-lg md:text-xl text-gray-200 leading-relaxed max-w-lg">
                      {product.description}
                    </p>

                    <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-4">
                      <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-yellow-400">
                        ${product.price}
                      </span>
                      <div className="flex items-center space-x-1">
                        {[...Array(5)].map((_, i) => (
                          <svg
                            key={i}
                            className={`w-4 h-4 sm:w-5 sm:h-5 ${i < product.rating ? 'text-yellow-400' : 'text-gray-400'}`}
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                          </svg>
                        ))}
                        <span className="text-gray-300 ml-2 text-sm sm:text-base">({product.rating})</span>
                      </div>
                    </div>

                    <div className="mb-8 sm:mb-0">
                      <button
                        onClick={() => handleBuyNow(product.id)}
                        className="group relative inline-flex items-center px-4 sm:px-6 md:px-8 py-3 sm:py-4 bg-gradient-to-r from-yellow-400 to-orange-500 text-black font-bold text-sm sm:text-base md:text-lg rounded-full hover:from-yellow-300 hover:to-orange-400 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl touch-optimized"
                      >
                        <span className="mr-2">Buy Now</span>
                        <svg className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                        </svg>
                      </button>
                    </div>
                  </div>

                  {/* Product Image */}
                  <div className="hidden lg:block">
                    <div className="relative">
                      <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/20 to-orange-500/20 rounded-2xl blur-xl transform rotate-6" />
                      <img
                        src={product.image}
                        alt={product.name}
                        className="relative w-full max-w-md mx-auto rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-2 sm:left-4 top-1/2 transform -translate-y-1/2 bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white p-2 sm:p-3 rounded-full transition-all duration-300 hover:scale-110 touch-optimized"
      >
        <svg className="w-4 h-4 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-2 sm:right-4 top-1/2 transform -translate-y-1/2 bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white p-2 sm:p-3 rounded-full transition-all duration-300 hover:scale-110 touch-optimized"
      >
        <svg className="w-4 h-4 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>

      {/* Animated Dots Indicator */}
      <div className="absolute bottom-2 sm:bottom-4 left-1/2 transform -translate-x-1/2 flex items-center space-x-1 sm:space-x-2">
        {featuredProducts.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className="relative touch-optimized group"
          >
            <div className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all duration-500 ${
              index === currentSlide 
                ? 'bg-white scale-125 animate-pulse' 
                : 'bg-white/50 hover:bg-white/75 hover:scale-110'
            }`}>
              {/* Animated ring for active dot */}
              {index === currentSlide && (
                <div className="absolute inset-0 rounded-full border-2 border-white/40 animate-ping" />
              )}
              {/* Ripple effect on hover */}
              <div className="absolute inset-0 rounded-full bg-white/20 scale-0 group-hover:scale-150 transition-transform duration-300" />
            </div>
          </button>
        ))}
      </div>

      {/* Slide Counter */}
      <div className="absolute top-4 sm:top-6 right-4 sm:right-6 bg-black/30 backdrop-blur-sm text-white px-2 sm:px-4 py-1 sm:py-2 rounded-full text-xs sm:text-sm font-medium">
        {currentSlide + 1} / {featuredProducts.length}
      </div>
    </div>
  );
};

export default ProductSlider;
